/* Winterfeldt – Warenkorb-Seite (sections/wf-warenkorb.liquid) und Seitenleiste (sections/cart-drawer.liquid) */
(() => {
  if (window.__wfWk) return;
  window.__wfWk = true;

  const LAGER = 'Mehr haben wir davon gerade leider nicht auf Lager.';
  const root = () => document.querySelector('[data-wk-root]');
  const euro = (c) => (c / 100).toFixed(2).replace('.', ',') + ' €';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* Herstellername vorne im Titel entfernen – gleiche Regeln wie snippets/wf-titel-kurz.liquid */
  const kurz = (t, v) => {
    if (!t || !v) return t;
    const vl = v.toLowerCase().trim();
    for (const sep of [' | ', ' l ', ' I ']) {
      const i = t.indexOf(sep);
      if (i > 0) {
        const vor = t.slice(0, i).toLowerCase().trim();
        if (vor.startsWith(vl) || (vor.length > 1 && vl.startsWith(vor))) {
          const r = t.slice(i + sep.length).trim();
          return r || t;
        }
        return t;
      }
    }
    if (t.toLowerCase().startsWith(vl) && /^[\s\-–]/.test(t.slice(vl.length))) {
      const r = t.slice(vl.length).trim().replace(/^[-–]\s*/, '').trim();
      return r || t;
    }
    return t;
  };

  const zaehler = (cart) => {
    document.querySelectorAll('.wf-head__count').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  };

  /* ---------------- Zur Kasse: Absicherung ---------------- */
  /* Startet nach dem Klick keine Weiterleitung (z. B. weil ein anderes Skript das Formular abfängt), direkt zu /checkout */
  document.addEventListener('click', (e) => {
    const k = e.target.closest('.wf-wkd__kasse, .wf-wk__kasse');
    if (!k || k.tagName !== 'BUTTON' || k.name !== 'checkout') return;
    let unterwegs = false;
    const weg = () => { unterwegs = true; };
    window.addEventListener('beforeunload', weg, { once: true });
    window.addEventListener('pagehide', weg, { once: true });
    setTimeout(() => {
      if (!unterwegs && document.visibilityState === 'visible') location.assign((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'checkout');
    }, 2000);
  }, true);

  /* ---------------- Seitenleiste ---------------- */

  /* Die Seitenleiste wird beim Öffnen vom Theme im DOM verschoben – Sektion daher über die ID suchen */
  const leistenSektion = (drawer) => {
    const s = (drawer && drawer.closest('.shopify-section')) || document.querySelector('.shopify-section[id$="__cart-drawer"], #shopify-section-cart-drawer');
    return s ? s.id.replace('shopify-section-', '') : null;
  };

  async function leisteMenge(item, q) {
    const sid = leistenSektion(item.closest('cart-drawer'));
    item.classList.add('is-busy');
    let fehler = '';
    try {
      const body = { id: item.dataset.key, quantity: q };
      if (sid) { body.sections = [sid]; body.sections_url = location.pathname; }
      const res = await fetch('/cart/change.js', { method: 'POST', headers: json, body: JSON.stringify(body) });
      const j = await res.json();
      if (res.ok) {
        zaehler(j);
        if (sid && j.sections && j.sections[sid]) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'line-item:change', cart: j } }));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
        return;
      }
      fehler = res.status === 422 ? LAGER : (j.description || j.message || 'Das hat leider nicht geklappt.');
    } catch (e) {
      fehler = 'Verbindung fehlgeschlagen – bitte noch einmal versuchen.';
    }
    item.classList.remove('is-busy');
    const el = item.querySelector('.wf-wkd__fehler');
    if (el && fehler) { el.textContent = fehler; el.hidden = false; }
  }

  /* ---------------- Warenkorb-Seite ---------------- */

  async function neuLaden() {
    const r = root();
    if (!r) return;
    try {
      const res = await fetch(location.pathname + '?section_id=' + encodeURIComponent(r.dataset.section));
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const neu = doc.querySelector('[data-wk-root]');
      if (!neu) { location.reload(); return; }
      r.replaceWith(neu);
    } catch (e) {
      location.reload();
      return;
    }
    init();
  }

  async function menge(key, q) {
    const r = root();
    if (r) r.classList.add('is-busy');
    let fehler = '';
    try {
      const res = await fetch('/cart/change.js', { method: 'POST', headers: json, body: JSON.stringify({ id: key, quantity: q }) });
      const j = await res.json();
      if (res.status === 422) fehler = LAGER;
      else if (!res.ok) fehler = j.description || j.message || 'Das hat leider nicht geklappt.';
      else zaehler(j);
    } catch (e) {
      fehler = 'Verbindung fehlgeschlagen – bitte noch einmal versuchen.';
    }
    if (fehler) {
      try { zaehler(await (await fetch('/cart.js')).json()); } catch (e) {}
    }
    await neuLaden();
    if (fehler) {
      const el = document.querySelector('[data-key="' + CSS.escape(key) + '"] .wf-wk__fehler');
      if (el) { el.textContent = fehler; el.hidden = false; }
    }
  }

  async function dazuLegen(btn) {
    btn.disabled = true;
    btn.textContent = '…';
    const r = root();
    if (r) r.classList.add('is-busy');
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [{ id: Number(btn.dataset.wkDazuAdd), quantity: 1 }] }) });
      if (res.ok) zaehler(await (await fetch('/cart.js')).json());
    } catch (e) {}
    await neuLaden();
  }

  const cache = {};
  async function empfehlungen(pid) {
    if (cache[pid]) return cache[pid];
    const alle = [];
    for (const intent of ['complementary', 'related']) {
      try {
        const j = await (await fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=' + intent)).json();
        for (const p of j.products || []) if (!alle.some((x) => x.id === p.id)) alle.push(p);
      } catch (e) {}
    }
    return (cache[pid] = alle);
  }

  async function ladeDazu() {
    const box = document.querySelector('[data-wk-dazu]');
    if (!box || !box.dataset.pid) return;
    const drin = box.dataset.drin.split(',');
    const liste = (await empfehlungen(box.dataset.pid))
      .filter((p) => p.available && !drin.includes(String(p.id)) && !/\b(abo|gutschein)/i.test(p.title))
      .slice(0, 3);
    if (!liste.length || !box.isConnected) return;
    box.querySelector('ul').innerHTML = liste.map((p) => {
      const v = (p.variants || []).filter((x) => x.available);
      const bild = p.featured_image ? (p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image) : '';
      const src = bild ? bild + (bild.includes('?') ? '&' : '?') + 'width=300' : '';
      const preis = (p.price_varies ? 'ab ' : '') + euro(p.price);
      const knopf = (p.variants || []).length === 1 && v.length
        ? '<button type="button" class="wf-wk__karte-knopf" data-wk-dazu-add="' + v[0].id + '" aria-label="' + esc(p.title) + ' in den Warenkorb">+ Dazu</button>'
        : '<a class="wf-wk__karte-knopf" href="' + esc(p.url) + '">Auswählen</a>';
      return '<li><div class="wf-wk__karte">' +
        '<a class="wf-wk__karte-bild" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<span class="wf-wk__karte-marke">' + esc(p.vendor) + '</span>' +
        '<a class="wf-wk__karte-titel" href="' + esc(p.url) + '">' + esc(kurz(p.title, p.vendor)) + '</a>' +
        '<div class="wf-wk__karte-fuss"><span class="wf-wk__karte-preis">' + preis + '</span>' + knopf + '</div>' +
        '</div></li>';
    }).join('');
    box.hidden = false;
  }

  function init() {
    if (!root()) return;
    ladeDazu();
    const k = document.querySelector('.wf-wk__box .wf-wk__kasse');
    const l = document.querySelector('.wf-wk__leiste');
    if (k && l && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => l.classList.toggle('is-weg', e.isIntersecting)).observe(k);
    }
  }

  /* ---------------- Ereignisse ---------------- */

  document.addEventListener('click', (e) => {
    const d = e.target.closest('[data-wkd-menge]');
    if (d) {
      e.preventDefault();
      const item = d.closest('[data-key]');
      if (item) leisteMenge(item, Math.max(0, Number(d.dataset.wkdMenge)));
      return;
    }
    const b = e.target.closest('[data-wk-root] [data-wk-menge]');
    if (b) {
      e.preventDefault();
      menge(b.closest('[data-key]').dataset.key, Math.max(0, Number(b.dataset.wkMenge)));
      return;
    }
    const a = e.target.closest('[data-wk-dazu-add]');
    if (a) { e.preventDefault(); dazuLegen(a); }
  });

  document.addEventListener('change', (e) => {
    const f = e.target.closest('[data-wk-root] [data-wk-feld]');
    if (f) menge(f.closest('[data-key]').dataset.key, Math.max(0, parseInt(f.value, 10) || 0));
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-wk-feld]')) { e.preventDefault(); e.target.blur(); }
  });

  let notizTimer;
  document.addEventListener('input', (e) => {
    const n = e.target.closest('[data-wk-notiz]');
    if (!n) return;
    clearTimeout(notizTimer);
    notizTimer = setTimeout(() => {
      fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ note: n.value }) });
    }, 500);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
